module.exports = __webpack_public_path__ + "img/34800.44807382.jpg";